import gql from 'graphql-tag';

const GET_ORDER_DETAILS_IMP = (gid: String) => (
  `query data {
        order(id: "${gid}") {
          lineItems (first: 100) {
            edges {
              node {
                title
                quantity
                fulfillmentService { 
                  serviceName
                }
                fulfillmentStatus
                fulfillableQuantity
                originalUnitPriceSet {
                  shopMoney {
                    amount
                  }
                }
              }
            }
          }
        }
      }`);

const GET_ORDER_DETAILS = (id: string) => {
  const contents = GET_ORDER_DETAILS_IMP(`gid://shopify/Order/${id}`);
  return gql`${contents}`;
};

export default GET_ORDER_DETAILS;
